import { GRAMMAR, PLAGIARISM } from '@src/components/Cards/constants'
import {
  CardContent,
  CardContentWithoutEK,
  EditorEntity,
  EntityComments,
} from '@src/components/Editor/types'
import {
  IC_CLARITY,
  IC_CONCISION,
  IC_FLUENCY,
  IC_GRAMMAR,
  IC_OTHER,
  IC_PUNCTUATION,
  IC_SPELLING,
  IC_STYLE,
  IC_TYPOS,
  IssueCategory,
} from '@src/components/Modals/PaperScorecardModal/types'
import { getCategoryFromType } from './selectors'
import { CheckCategory, EXPERT_CHECK } from './types'

interface LabeledIntersection {
  offset: number
  isEnd: boolean
  id: string
  length: number
}
export const getLabeledIntersections = (
  comments: Array<CardContent | CardContentWithoutEK>
): LabeledIntersection[] => {
  return comments.reduce((acc: LabeledIntersection[], card: CardContent) => {
    const start = {
      offset: card.start,
      isEnd: false,
      id: card.id,
      length: card.end - card.start,
    }
    const end = {
      ...start,
      offset: card.end,
      isEnd: true,
    }
    return [...acc, start, end]
  }, [])
}

export const getFlattenedRangesWithEntityData = (
  comments: Array<CardContent | CardContentWithoutEK>
): EditorEntity[] => {
  // refactor to be EntityComment
  let activeIds: string[] = []

  const intersections = getLabeledIntersections(comments)
  const sortedIntersections = getSortedIntersections(intersections)
  const skip = -1
  const entities = sortedIntersections.reduce<EditorEntity[]>(
    (
      acc: EditorEntity[],
      intersectionStart: LabeledIntersection,
      index: number,
      allIntersections: LabeledIntersection[]
    ) => {
      if (index === allIntersections.length - 1 || index < skip) {
        return acc
      }

      const { offset: start, id, isEnd } = intersectionStart
      const { offset: end } = allIntersections[index + 1]

      if (isEnd) {
        activeIds = activeIds.filter(i => i !== id)
      } else {
        activeIds = [...activeIds, id]
      }

      if (activeIds.length === 0 || start === end) {
        return acc
      }
      const data = activeIds.reduce<EntityComments>((acc, id) => {
        // TODO - don't look up comment
        acc[id] = getCategoryFromType(findCommentById(id, comments).type)
        return acc
      }, {})
      return [...acc, { offset: start, end, comments: data }]
    },
    []
  )
  return entities
}

export const getSortedIntersections = (intersections: LabeledIntersection[]) => {
  // intersections made in pairs for each card, necessary to sort because
  // [A1 A2 B1 B2].sort => [A1 B1 A2 B2
  return intersections.sort((a, b) => {
    if (a.offset - b.offset === 0) {
      // handles nesting detection, making the smaller range be on the inside
      // i.e if A1 = B1, and A.length < B.length
      // [B1 A1 A2 B2]
      // if both start or end at the same index
      if (a.isEnd === b.isEnd) {
        // if both are starts
        if (!a.isEnd) {
          if (a.length === b.length) {
            // a and b are perfectly overlapping
            return 1
          }
          return b.length - a.length
          // if both are end
        } else {
          if (a.length === b.length) {
            // a and b are perfectly overlapping
            return -1
          }
          return a.length - b.length
        }
      }
    }
    return a.offset - b.offset
  })
}

const findCommentById = (
  id: string,
  comments: Array<CardContent | CardContentWithoutEK>
) => comments.find(c => c.id === id) as CardContent

export const isCheckCategory = (category: any): category is CheckCategory =>
  [EXPERT_CHECK, GRAMMAR, PLAGIARISM].includes(category)

export const mapCommentCategoryToIssueCategory = (category: string): IssueCategory => {
  switch (category.toLowerCase()) {
    case 'fluency':
      return IC_FLUENCY
    case 'punctuation':
      return IC_PUNCTUATION
    case 'grammar':
      return IC_GRAMMAR
    case 'clarity':
      return IC_CLARITY
    case 'concision':
      return IC_CONCISION
    case 'spelling':
      return IC_SPELLING
    case 'typos':
      return IC_TYPOS
    case 'style':
      return IC_STYLE
    default:
      return IC_OTHER
  }
}



// WEBPACK FOOTER //
// ./src/state/document/helpers.ts